<template>
  <div class="header-block" :class="{k7:isK7}">
    <header class="header">
      <div class="header-wrapper">
        <router-link :to="mainLogoLink" class="logo">
          <logo :symbol="!$device.mobile()"/>
          <k7-logo v-if="isK7"/>
        </router-link>
        <MenuNav :pageLinks="pageDesktopLinks"/>
        <div class="menu-wrap">
          <search-field v-if="$device.desktop()"></search-field>
          <!-- <input type="text" placeholder="Raðnúmer, aukahlutir" id="search">-->
          <nav class="left-nav">
            <router-link
                to="/notifications"
                :class="{ active: $route.path == '/notifications' }"
            >
              <notification/>
            </router-link>
            <router-link
                to="/favorites"
                :class="{ active: $route.path == '/favorites' }"
            >
              <favorites/>
            </router-link>
            <a v-if="!user" @click.prevent="$store.state.popup = 'reg'">
              <img src="/img/profile/user-login.svg"/>
            </a>
            <router-link v-if="user" to="/profiles">
              <img class="circl" :src="$store.state.baseUrl + profile.pic"/>
            </router-link>

            <menu-btn/>
          </nav>
        </div>
      </div>
      <div class="mobile-header">
        <div class="mobile-header-left">
          <menu-btn v-if="!isApp"/>
          <VCarReturnLink v-if="isApp && isCarPage" isHeader/>
        </div>

        <div :class="['mobile-header-middle', { 'is-car-page': isCarPage, 'k7':showResultCountAndOrder && $route.name == 'k7Car'}]">
          <template v-if="showMenu">
            <RouterLink class="no-filter" :to="mainLogoLink">
              <logo :symbol="!$device.mobile() || isApp"/>
              <k7-logo v-if="isK7"/>
            </RouterLink>
          </template>

          <template v-else-if="showResultCountAndOrder">
            <h1 class="mobile-header-title expandable">
              {{ $store.state.resultCount }}
              <!-- leitarniðurstöður  -->
               niðurstöður
            </h1>

            <sort-menu :filters="filters"></sort-menu>
          </template>

          <!-- Show On car page, Mobile Version-->
          <template v-else-if="isCarPage" class="mobile-header-middle">
            <template v-if="!$store.state.popUpHeaderMenu">
              <div
                  class="ll"
                  :style="`${ $route.name == 'DealerCar' && $device.mobile() ? 'display: flex;justify-content: center;align-items: center;':''}`"
              >
                <div v-if="isOldCarPage" class="mobile-header-subtitle">
                  Raðnúmer
                </div>
                <svg
                    style="margin-right:5px;"
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 16"
                    width="24px"
                    height="16px"
                >
                  <path
                      fill="#fff"
                      fill-rule="nonzero"
                      d="M12.012 0C4.075 0 0 8 0 8s3.075 8 12.012 8c8.093 0 12.011-7.969 12.011-7.969S20.074 0 12.012 0zm.018 13c-2.902 0-5-2.188-5-5 0-2.813 2.098-5 5-5s5 2.187 5 5c0 2.812-2.098 5-5 5zm0-8c-1.658.003-3 1.393-3 3 0 1.606 1.342 3 3 3s3-1.395 3-3c0-1.608-1.342-3.003-3-3z"
                      opacity=".5"
                  />
                </svg>
                <h1 class="mobile-header-title expandable">
                  {{ isOldCarPage ? getCarId : getCarViews }}
                </h1>
              </div>
              <div class="ll">
                <div class="mobile-header-subtitle">Síðast uppfært</div>
                <h1 v-if="getDeyDiff" class="mobile-header-title expandable">
                  {{ getDeyDiff }}
                  dögum
                </h1>
              </div>
            </template>
            <template v-else>
              <RouterLink :to="mainLogoLink">
                <logo :symbol="!$device.mobile() || isApp"/>
              </RouterLink>
            </template>
          </template>

          <template v-else>
            <RouterLink class="no-filter" :to="mainLogoLink">
              <logo :symbol="!$device.mobile() || isApp"/>
              <k7-logo v-if="isK7"/>
            </RouterLink>
          </template>
        </div>
        <router-link
            v-if="!$store.state.popUpHeaderMenu && !isApp"
            to="/favorites"
            class="mobile-header-favorites-btn"
        >
          <Favorites width="26px" height="23px"/>
        </router-link>


        <div class="mobile-header-right">
          <template v-if="!$store.state.popUpHeaderMenu && (isApp ? showMenu : true)">
            <div @click="showMobileMenu" class="mobile-header-search-btn">
              <button v-if="showMenu" class="js-menu-mobile active">
                <div class="menu-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
              <Notification v-else width="27px" height="30px"/>
            </div>
          </template>
        </div>
        <template v-if="isApp">
          <menu-btn v-if="!isCarPage"/>
          <share-app-btn v-if="isApp && isCarPage"/>
        </template>
      </div>
      <transition name="showHeaderMenu">
        <app-menu
            v-show="$store.state.popUpHeaderMenu"
            :user="user"
            :profile="profile"
            :showElement="$store.state.popUpHeaderMenu"
        />
      </transition>
    </header>
    <div v-if="showMobileSubMenu" class="mobile-sub-menu" :class="{'show-filter':showMenu}">
      <div class="mobile-sub-menu__links">
        <a
            v-for="(page, index) in pageMobLinks"
            :key="index"
            :class="{ active: page.components.indexOf($route.name) >= 0 }"
            v-text="page.name"
            class="mobile-sub-menu__link"
            @click.prevent="
            resetStoreData(page);
            routerPush(page);
          "
        />
      </div>
      <div>
        <search-field v-if="$device.tablet()"></search-field>
      </div>
    </div>
    <save-search-block
        :filters="addFilersName"
        v-if="showSaveBlockFixed || isK7"
        class="fixed"
    />
  </div>
</template>

<script>
import SortMenu from "./SortMenu.vue";
import SearchField from "./SearchField.vue";
import AppMenu from "./Menu.vue";

import EventBus from "@/eventBus";
import Logo from "@/components/svg/Logo.vue";
import k7Logo from "@/components/k7/Logo";
import Favorites from "@/components/svg/Favorites.vue";
import Notification from "@/components/svg/Notification.vue";
import ShareAppBtn from "@/components/svg/ShareAppButton.vue";
import MenuBtn from "@/components/global/MenuBtn.vue";
import VCarReturnLink from "@/components/Dealers/CarReturnLink.vue";
import SaveSearchBlock from "@/components/Dealers/SaveSearchBlock.vue";
import MenuNav from "@/components/MenuNav";
import {mapGetters, mapMutations, mapState} from "vuex";

import mixinMobileLinks from "@/mixins/mobileLinks";
import func from "@/helpers/func";

export default {
  ...mapMutations(["setScrollTo"]),
  mixins: [mixinMobileLinks],
  components: {
    SortMenu,
    SearchField,
    AppMenu,
    Logo,
    k7Logo,
    Favorites,
    Notification,
    MenuBtn,
    ShareAppBtn,
    VCarReturnLink,
    SaveSearchBlock,
    MenuNav,
  },
  data: () => ({
    showRes: false,
    mainPos: 0,
  }),
  comments: {
    "sort-menu": SortMenu,
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapMutations(['setShowMenu']),
    resetAll() {
      EventBus.$emit("resetAllFilters");
      this.resetScrollTop();
    },
    resetScrollTop() {
      this.$store.state.scrollPositionPageDealers = 0;
    },
    handleScroll() {
      if (!this.mainPos) {
        this.mainPos = $(".main").position().top;
      }

      this.$store.commit("setScrollTo", window.pageYOffset);

      if (
          Math.round($(document).scrollTop() + 500) >= this.mainPos &&
          this.selectedFiltersCount > 0
      ) {
        this.showRes = true;
      } else {
        this.showRes = false;
      }
    },
    showMobileMenu() {
      const carsPage = ['k7Cars', 'OldCars', 'DealersCars'];
      //const validPages = carsPage.concat(['Car', 'DealerCar', 'k7Car']);

      /*if (!validPages.includes(this.$route.name)) {
        this.$router.push({name: 'DealersCars'});
        this.setShowMenu(true);
        console.log("validPages",validPages);
      }*/
      if (!carsPage.includes(this.$route.name)) {
        if (this.lastCarPageVisit.name && this.lastCarPageVisit.name === 'Blog') {
          this.$router.push({name: 'DealersCars'});
        } else if (this.lastCarPageVisit.name && this.lastCarPageVisit.name == 'Car') {
          this.$router.push({name: 'OldCars'});
        } else if (this.lastCarPageVisit.name && this.lastCarPageVisit.name == 'DealerCar') {
          this.$router.push({name: 'DealersCars'});
        } else if (this.lastCarPageVisit.name) {
          this.$router.push({name: this.lastCarPageVisit.name});
        } else {
          this.$router.push({name: 'DealersCars'});
        }
        this.setShowMenu(true);
      } else {
        this.setShowMenu(!this.showMenu);
      }
    }
  },
  watch: {
    $route() {
      this.$store.state.popUpHeaderMenu = false;
      this.$store.commit("setScrollTo", 0);
      //this.scrollTop = 0;
      //this.$store.state.saveBtnMobileHide = false;
    },
  },
  computed: {
    ...mapGetters(['showMenu', 'lastCarPageVisit', 'LIB']),
    ...mapState({
      selectedFiltersCount: (state) => state.selected_filters_count,
      user: (state) => state.profile.user,
      profile: (state) => state.profile.profile,
      carId: (state) => state.car_id,
      filters: (state) => state.filter,
      scrollTop: (state) => state.scrollTop,
      scrollTopOldCars: (state) => state.moduleOldCars.cars.scrollTop,
      isApp: (state) => state.isApp,
      selectedFilterCount: (state) => state.selected_filters_count
    }),
    isK7() {
      return (this.$route.name === 'k7Cars' || this.$route.name === 'k7Car');
    },
    isCarPage() {
      return ["Car", "DealerCar", "CarInStock",'k7Car'].indexOf(this.$route.name) >= 0;
    },
    pageDesktopLinks() {
      return this.$store.state.pageLinks.filter(function (e) {
        return e.target && e.target.indexOf("desktop") >= 0;
      });
    },
    pageMobLinks() {
      return this.$store.state.pageLinks.filter(function (e) {
        return e.target && e.target.indexOf("mobile") >= 0;
      });
    },
    showLogo() {
      return this.$router.currentRoute.name != "DealerCar" ? this.scrollTop : 0;
    },
    getCarId() {
      if (this.isOldCarPage) {
        return this.$store.state.car_data
            ? this.$store.state.car_data.api_id
            : null;
      } else if (this.isNewOrStockCars) {
        if (!this.$store.state.dealers.newCar) {
          return null;
        }
        return this.$store.state.dealers.newCar.car_api_id
            ? this.$store.state.dealers.newCar.car_api_id
            : this.$store.state.dealers.newCar.id;
      }
    },
    getCarViews() {
      if (this.isOldCarPage) {
        return this.$store.state.car_data
            ? this.$store.state.car_data.views
            : null;
      } else if (this.isNewOrStockCars) {
        if (!this.$store.state.dealers.newCar) {
          return null;
        }
        return this.$store.state.dealers.newCar.views
            ? this.$store.state.dealers.newCar.views
            : this.$store.state.dealers.newCar.views;
      }
    },
    getDeyDiff() {
      if (this.isOldCarPage && this.$store.state.car_data) {
        return this.moment().diff(
            this.moment(this.$store.state.car_data.lastupdated, "YYYY-MM-DD"),
            "days"
        );
      } else if (this.isNewOrStockCars && this.$store.state.dealers.newCar) {
        return this.moment().diff(
            this.moment(this.$store.state.dealers.newCar.updated, "YYYY-MM-DD"),
            "days"
        );
      }
    },
    isNewOrStockCars() {
      return (
          this.$route.name == "DealerCar" || this.$route.name == "CarInStock"
      );
    },
    showMobileSubMenu() {
      return (
          (this.$device.mobile() || this.$device.tablet()) && this.scrollTop < 300
      );
    },
    showSaveBlockFixed() {
      return (
          // this.$store.state.saveBtnMobileHide && this.$route.name == "DealersCars"
          this.selectedFilterCount > 0 &&
          ["CarsInStock", "DealersCars", "OldCars", "k7Cars"].indexOf(this.$route.name) >= 0
      );
    },
    mainLogoLink() {
      if(['k7Cars', 'k7Car'].includes(this.$route.name)){
        return {name: 'k7Cars', query: null}
      }else if (['OldCars', 'Car'].includes(this.$route.name)) {
        if (['OldCars', 'Car'].includes(this.$route.name) && this.filters && this.filters.k7) {
          this.filters.k7 = false;
        }
        return {name: 'OldCars', query: null}
      }
      return {name: 'DealersCars', query: null}
    },
    addFilersName() {
      return func.addFilersName(func.cleanFilters(this.filters), this.LIB)
    },
    showResultCountAndOrder(){
        return !this.showMenu && !this.$store.state.popUpHeaderMenu && this.selectedFilterCount > 0;
    },
    isOldCarPage(){
      return ['k7Car','Car'].includes(this.$route.name);
    }
  },
};
</script>
